<template>
  <div ref="canvas_wrapper" id="canvas_wrapper">
    <canvas  ref="canvas"  height="1000px" width="1000px"  id="canvas"></canvas>
  </div>
</template>

<script>
import CanvasImgMark from "@/plugins/CanvasImgMark";
export default {
  name: "MarkCanvas",
  props:['archiveImgSrc'],
  data() {
    return {
      archiveImg : new Image(),
      canvas : null,
      canvasManager : null,
      wrapper : null,
    }
  },
  methods:{
    canvasMarked(rectangleMark){
      let block =  rectangleMark.fix().scale(1/this.getRatio(this.canvas))
      this.$emit('marked', { block, canvasManager : this.canvasManager})
    },
    getRatio(el){
      let hRatio =   el.clientWidth / this.archiveImg.width
      return hRatio
    },
    initCanvas(){
      let hRatio = this.getRatio(this.wrapper)
      this.canvas.setAttribute('width',this.archiveImg.width * hRatio )
      this.canvas.setAttribute('height',this.archiveImg.height * hRatio)
      this.canvasManager.erase()
    },
    onCanvasResize(){
      let oldwidth = this.canvas.width
      this.initCanvas()
      this.canvasManager.scaleCoords(this.canvas.width / oldwidth)
      this.canvasManager.redrawWithLastColor()
    }
  },
  mounted() {
    this.wrapper = document.querySelector('#canvas_wrapper')
    this.canvas = this.$refs.canvas
    this.canvasManager = new CanvasImgMark(this.canvas.getContext('2d'))
    this.canvasManager.onMarked = this.canvasMarked
    new ResizeObserver(this.onCanvasResize).observe(this.wrapper)
    this.archiveImg.onload = () => {
      this.canvas.style.border = '1px solid'
      this.canvasManager.setImg(this.archiveImg)
      this.initCanvas()
    };
  },
  watch:{
    archiveImgSrc: function(val){
      this.archiveImg.src = val
    }
  }
}
</script>

<style scoped>
#canvas{
  /*border :1px solid;*/
}
</style>